export interface HumanitarianProject {
  id: string
  title: string
  tagline: string
  description: string
  month: string
}

export const humanitarianProjects: HumanitarianProject[] = [
  {
    id: 'school-edition',
    title: 'IBON World Ready: School Edition',
    tagline: 'Start school with confidence.',
    description:
      'Every child deserves a strong start. IBON Ready: School Edition is IBON World\u2019s September donation drive to equip pupils across Ghana with school bags, books, uniforms, and shoes. We\u2019re collecting donations to make sure no child starts the school year unprepared. Donate today to support a student.',
    month: 'September',
  },
  {
    id: 'december-care',
    title: 'IBON Care: December Edition',
    tagline: 'No one forgotten this season.',
    description:
      'The holidays should be a time of warmth and dignity for all. IBON Care: December Edition is IBON World\u2019s end-of-year drive to provide food, warm clothes, blankets, and gift items for orphans and homeless individuals in our communities. Join us in making sure no one is left out this December. Donate today to spread care.',
    month: 'December',
  },
]
